var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center contents_modal" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "1000", relative: "", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _vm._t("close", function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-auto dialog__close ",
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.modal_open },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "contents_modal__content" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline pt-5 pb-1  py-5" },
                [
                  _vm._t("img", function () {
                    return [_c("div", { staticClass: "img" })]
                  }),
                  _vm._v(" "),
                  _vm._t("title", function () {
                    return [
                      _c("div", { staticClass: "h2_title h2_title--modal" }),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "contents_modal__descr",
                  style: { height: _vm.autoheight + "px" },
                },
                [
                  _c(
                    "vue-scroll",
                    { attrs: { ops: _vm.ops_scrollbar } },
                    [_vm._t("content")],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }